import styles from "./Credits.module.css"

export const classes = {
  card: [styles.Card]
}
